// @ts-nocheck
/**
 * AppStoreRef — singleton bridge so non-React modules (Error_Handler, etc.)
 * can fire toasts without prop-drilling or context hooks.
 *
 * Usage inside AppProvider:
 *   import { appStoreRef } from './AppStoreRef';
 *   appStoreRef.addToast = (type, message) => toast(message, type);
 */

type ToastType = 'info' | 'success' | 'warn' | 'danger';

export const appStoreRef: {
  addToast: ((type: ToastType, message: string) => void) | null;
} = {
  addToast: null,
};
